import type { FaireProductEntity } from "../../entity_types/product";

export const p_2k6et7rnxa: FaireProductEntity = {
  token: "p_2k6et7rnxa",
  type: "product",
  name: "EMBROIDERED POCKET DETAIL SWEATER TOP",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/55b8320fea497432fd0c257112e8d8d8d8dd1f1694ab132b9c6b2801a382f8eb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa6f9e5269fdc71da4f332f3a1b4712dacd20cc25067d69cf692f83c11c12127.jpeg",
    "https://cdn.faire.com/fastly/f2264d335f484ca50c57570cc99f2697341a8450a03ae2662267b0d6bf28de5c.jpeg",
    "https://cdn.faire.com/fastly/5180b6eaf9b85cca32b58bd274fe765d07e8823beed3e468963b148892bcb779.jpeg",
    "https://cdn.faire.com/fastly/92eb2ecbf1ab8d72f93f57777048304cb0cd69a62ae8455fd8b51e6151d0642e.jpeg",
    "https://cdn.faire.com/fastly/9e88cbdc7530d981d69dfdd935c3cc5898f3d5b44e89f9df3788ebe3e7c9d843.jpeg",
    "https://cdn.faire.com/fastly/7402d11306ddb1b4fae9c4fa17585bb8c81429accce41afcd6530cafda1fa54e.jpeg",
    "https://cdn.faire.com/fastly/d20e59d0213fe5529cf3a44c780e3890d45d9a9c0ef22d9f0b63e8190a961db5.jpeg",
    "https://cdn.faire.com/fastly/2684ea59efd8c22bca076bcb2010466c975ae2c2eec64ec04e6fd9a2424c4aa7.jpeg",
    "https://cdn.faire.com/fastly/304117096c3aa972eda7639ae27f8fa1b412c46193b6bec9088722b27b9159a0.jpeg",
  ],
  priceDollars: 150,
  description:
    '\n\nMODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'8"\nBUST: 32B\nWAIST: 24"\nHIPS: 34"\n',
  tags: [],
  msrpDollars: 300,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:10.223Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
